module.exports = __webpack_public_path__ + "static/media/pr.2253d22a.svg";